import { BrowserAuthOptions, BrowserCacheLocation, BrowserSystemOptions, CacheOptions, LogLevel } from "@azure/msal-browser";

export const environment = {
    name: 'qa',
    production: false,
    msal: {
        auth: {
            clientId: 'eace2e84-e3ec-4051-8dc1-80f375e85294', // App registration client ID
            authority: 'https://login.microsoftonline.com/6616ee5b-8b46-400c-a543-b03d372342ce/', // Tenant ID
            redirectUri: 'https://utils.d3s.com.au',
            postLogoutRedirectUri: 'https://utils.d3s.com.au',
        } as BrowserAuthOptions,
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: true,
        } as CacheOptions,
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: string) => {
                    console.log(message);
                },
                logLevel: LogLevel.Verbose,
                piiLoggingEnabled: true
            } 
        } as BrowserSystemOptions,
    },
    ssoDomainManagementApi: {
        serviceBaseUrl: 'https://neuroqa.d3s.com.au/NeuroUtils.SsoDomainManagement.Api/SsoDomain/',
        serviceEndpoint: 'https://neuroqa.d3s.com.au/'
    },
    tenantManagementApi: {
        serviceBaseUrl: 'https://neuroqa.d3s.com.au/NeuroUtils.TenantManagement.Api/TenantManagement',
        serviceEndpoint: 'https://neuroqa.d3s.com.au/'
    },
    workspaceApi: {
        serviceBaseUrl: 'https://neuroqa.d3s.com.au/NeuroUtils.TenantManagement.Api/Workspace',
        serviceEndpoint: 'https://neuroqa.d3s.com.au/'
    },
    catalogApi: {
        serviceBaseUrl: 'https://neuroqa.d3s.com.au/NeuroUtils.TenantManagement.Api/Catalog',
        serviceEndpoint: 'https://neuroqa.d3s.com.au/'
    },
    dataStoreApi: {
        serviceBaseUrl: 'https://neuroqa.d3s.com.au/NeuroUtils.TenantManagement.Api/DataStore',
        serviceEndpoint: 'https://neuroqa.d3s.com.au'
    },
    signalRHub: {
        serviceBaseUrl: 'https://neuroqa.d3s.com.au:8080/signalrcoreservice/neuroutilshub',
        serviceEndpoint: 'https://neuroqa.d3s.com.au/'
    },
    appScopes: [
        'd6e56875-2190-47a2-bccd-bd9961644d8a/user_impersonation',
    ],
}